import { Injectable } from '@angular/core';
import { DateService } from '../date/date.service';
import { TranslateService } from '@ngx-translate/core';
import { GenderPrefixPipe } from '@shared/pipes/gender-prefix/gender-prefix.pipe';
import { ContentText, ContentTable } from 'pdfmake/interfaces';
import { DateFormatEnum } from '../../../core/enums/date-format.enum';

@Injectable({
  providedIn: 'root',
})
export class MainbookerDetailsPdfService {
  constructor(private translateService: TranslateService, private dateService: DateService, private genderPrefixPipe: GenderPrefixPipe) {}

  private getGenderPrefix(gender: string): string {
    return this.translateService.instant(this.genderPrefixPipe.transform(gender));
  }

  public getContent(booker): [ContentText, ContentTable] {
    const content = {
      body: [
        [
          {
            text: `${this.getGenderPrefix(booker.gender)} ${booker.firstName} ${booker.lastName} \n
            ${this.translateService.instant('PRINT.DATE_OF_BIRTH')}\n ${this.dateService.formatDate(
              booker.dateOfBirth,
              DateFormatEnum.PDFdMMMyyyy
            )} \n
            ${this.translateService.instant('PRINT.EMAIL_ADDRESS')}\n ${booker.email} \n
            ${this.translateService.instant('PRINT.PHONE')}\n ${booker.phoneNumberPrefix} ${booker.phone}`,
          },
        ],
      ],
      widths: [250],
    };

    return [
      { text: `${this.translateService.instant('PRINT.MAINBOOKER')}`, style: 'sectionheader' },
      { table: content, margin: [0, 0, 0, 20] },
    ];
  }
}
